import type { OwnerActionOutcome } from '../../../../../bridge/types/action.ts';

// How each answer reads. Three outcomes, three readings, shared by the ask's own
// panel and its row on the campaign — the same answer must not look finished in
// one place and open in the other.
//
// "It didn't happen" deliberately keeps the same `notice` as an unanswered ask:
// the owner still means to do it, so it stays open-looking rather than borrowing
// the green of a finished step. Opting out is `neutral` — a choice, never an
// error.
export const OUTCOME_VARIANT: Record<
	OwnerActionOutcome,
	'positive' | 'notice' | 'neutral'
> = {
	done: 'positive',
	not_done: 'notice',
	declined: 'neutral',
};

export const OUTCOME_LABEL: Record<OwnerActionOutcome, string> = {
	done: 'You told us',
	not_done: "Didn't happen",
	declined: 'Skipped',
};
